import { getIssueCausesDropdown } from '@martech-solution/utils/apis';
import { HierarchicalItem, IIssueCause, TreeItem } from '@martech-solution/utils/types';
import { useQuery } from '@tanstack/react-query';
import { TreeSelect } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import { buildHierarchySelect } from 'src/utils/collection';

interface Props {
  value?: number;
  style?: React.CSSProperties | undefined;
  allowClear?: boolean | undefined;
  onChange?: (value: number, option: IIssueCause) => void;
  placeholder?: ReactNode;
  disabled?: boolean;
  className?: string;
  popupMatchSelectWidth?: number;
}

export default function IssueCauseSelect({
  value,
  style,
  allowClear = true,
  onChange,
  placeholder,
  disabled,
  className,
  popupMatchSelectWidth
}: Props) {
  const [objectGroupTreeItem, setObjectGroupTreeItem] = useState<TreeItem[] | undefined>(undefined);

  const issueCausesDropdownQuery = useQuery({
    queryKey: ['issueCausesDropdownQuery'],
    queryFn: () => getIssueCausesDropdown(),
    staleTime: 60 * 1000
  });

  useEffect(() => {
    const result = buildHierarchySelect(issueCausesDropdownQuery.data?.data);
    setObjectGroupTreeItem(result);
  }, [issueCausesDropdownQuery.data?.data]);

  console.log(issueCausesDropdownQuery.data?.data);

  return (
    <TreeSelect
      popupMatchSelectWidth={popupMatchSelectWidth ?? 300}
      treeLine={true}
      value={issueCausesDropdownQuery.isFetching ? undefined : value}
      disabled={disabled}
      showSearch
      placeholder={placeholder}
      className={className}
      style={style}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      treeNodeFilterProp='value'
      allowClear={allowClear}
      onChange={(value) => {
        const obj = issueCausesDropdownQuery.data?.data?.find((x) => x.id === Number(value));
        onChange && onChange(value, obj);
      }}
      treeData={objectGroupTreeItem}
      loading={issueCausesDropdownQuery.isFetching}
      filterTreeNode={(inputValue, treeNode) => {
        return treeNode.title?.toString().toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) ?? false;
      }}
    />
  );
}
